import { API_ROUTES } from "../constants";
import { HTTP_CONFIG } from "../defineTdm";
import axios, { AxiosResponse } from "axios";

export const getTripGroupUsers = async (tripGroupId?: string): Promise<AxiosResponse> => {
  const url = API_ROUTES.tripGroupUsers.replace(':tripGroupId', tripGroupId || '');
  try {
    const response = await axios.get(url, HTTP_CONFIG);
    return response;
  } catch (error) {
    console.error(`Error fetching data for trip group ID ${tripGroupId}:`, error);
    throw error;
  }
}

export const getTripGroupsUsers = async (tripGroupsIds: Record<string, any>): Promise<AxiosResponse> => {
  try {
    const response = await axios.post(API_ROUTES.tripGroupsUsers, tripGroupsIds, HTTP_CONFIG);
    return response;
  } catch (error) {
    console.error("Error fetching trip groups users:", error);
    throw error;
  }
}